import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { notifyAppReady } from './services/liveUpdate'
import { initErrorReporting } from './lib/errorReporter'
import { initStaleChunkReload } from './lib/staleChunkReload'

// Confirm to the live-update plugin that this bundle booted. Must happen within
// appReadyTimeout (10s) or the plugin rolls back to the previous bundle — so it
// runs before render and is deliberately not awaited. No-op on web.
notifyAppReady()

// Before render, so a crash during the first paint is still reported. Installs
// the window.onerror / unhandledrejection handlers that an ErrorBoundary can
// never see — a boundary only catches errors thrown during render.
// First, so a stale-chunk rejection is handled (and marked) before the
// reporter's own unhandledrejection listener sees it. See staleChunkReload.ts.
initStaleChunkReload()
initErrorReporting()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary boundary="root">
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
